import React from 'react';
import Multiselect, {MultiselectProps} from './Multiselect';
import {useField} from 'formik';

export type FormikMultiselectProps = {
  name: string;
} & Pick<MultiselectProps, 'options' | 'maximumSelections' | 'allowNew' | 'placeholder'>;

const FormikMultiSelect = ({
  name,
  options,
  maximumSelections,
  allowNew = false,
  placeholder = 'Select...',
}: FormikMultiselectProps) => {
  const [field, meta, helpers] = useField<string[]>({name, multiple: true});
  const selectedValue = field.value || [];

  return (
    <Multiselect
      error={meta.touched ? meta.error : ''}
      placeholder={placeholder}
      allowNew={allowNew}
      id={name}
      selected={selectedValue}
      onSelect={(value: string): void => {
        helpers.setTouched(true);
        helpers.setValue([...selectedValue, value]);
      }}
      onDelete={(deleted: string): void => {
        helpers.setTouched(true);
        helpers.setValue(field.value.filter((value) => value !== deleted));
      }}
      options={options}
      maximumSelections={maximumSelections}
      onBlur={(e) => {
        helpers.setTouched(true);
        field.onBlur(e);
      }}
    />
  );
};

/**
 * @deprecated No new uses.
 * TODO: Tech-Debt create a new better version of this
 */
export default FormikMultiSelect;
